import { MetaDataState } from "@medapro-types/common/metadata";
import _ from "lodash";
import { computed } from "vue";
import { createNamespacedHelpers } from "vuex-composition-helpers";

const { useState } = createNamespacedHelpers<MetaDataState>("metadata");

export function useContentLanguages() {
  const { contentLanguages, localizedLanguages } = useState(["contentLanguages", "localizedLanguages"]);
  const primaryLanguage = computed(() => contentLanguages.value.enabled[0]);
  const primaryLanguageCode = computed(() => primaryLanguage.value.languageCode);
  const languages = computed(() => contentLanguages.value.enabled.map((x) => x));
  const languageCodesWithFallback = computed(() => {
    const languageCodes = contentLanguages.value.enabled.flatMap((x) => [x.languageCode, x.fallbackLanguageCode]).filter((x) => !!x);
    return Array.from(new Set(languageCodes));
  });
  const languageCodes = computed(() => contentLanguages.value.enabled.map((x) => x.languageCode));
  const languageCount = computed(() => contentLanguages.value.enabled.length);
  const translatedLanguages = computed(() => _.tail(contentLanguages.value.enabled));
  return {
    contentLanguages,
    localizedLanguages,
    primaryLanguage,
    primaryLanguageCode,
    languages,
    languageCodesWithFallback,
    languageCodes,
    languageCount,
    translatedLanguages
  };
}

export function useConfig() {
  const { config } = useState(["config"]);
  return { config };
}
